"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationListRowEditComponent = void 0;
const angular2_modal_1 = require("angular2-modal");
const _ = require("lodash");
const core_1 = require("@angular/core");
const angular2_modal_2 = require("angular2-modal");
const update_dfp_networks_modal_component_1 = require("./update-dfp-networks-modal.component");
const admin_service_1 = require("./admin.service");
const lineitem_automation_service_1 = require("./lineitem-automation.service");
const notification_service_1 = require("./notification.service");
const organizations_service_1 = require("./organizations.service");
const organization_1 = require("./organization");
const permission_1 = require("./permission");
const lodash_1 = require("lodash");
class EditOrg extends organization_1.Organization {
}
let OrganizationListRowEditComponent = class OrganizationListRowEditComponent {
    constructor(_admin, _cd, _lia, _organizations, _talk, modal) {
        this._admin = _admin;
        this._cd = _cd;
        this._lia = _lia;
        this._organizations = _organizations;
        this._talk = _talk;
        this.modal = modal;
        this.roleDropDownOrg = [];
        this.reload = new core_1.EventEmitter();
    }
    ngOnInit() {
        this.editOrg = new organization_1.Organization((0, lodash_1.cloneDeep)(this.organization));
        this.editOrg.organization_roles = this.editOrg.roles.map(({ id }) => id);
    }
    cancel() {
        this.organization.editing = false;
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.editOrg.loading = true;
            if (!this.editOrg.organization_roles ||
                !this.editOrg.organization_roles.length) {
                this._talk.broadcast(`Oops! It looks like you did not assign a role to this organization <i class="fa fa-smile-o" aria-hidden="true"></i>`);
                this.editOrg.loading = false;
                return;
            }
            try {
                const networkCodesToUpdate = this.getNetworkCodesToUpdate();
                yield Promise.all([
                    this._admin.updateOrganization(this.editOrg),
                    networkCodesToUpdate.length &&
                        this.updateDfpNetworkCodes(networkCodesToUpdate),
                ]);
                yield this._organizations.pull();
                this._cd.markForCheck();
                this._talk.broadcast(`Organization updated! <i class="fa fa-smile-o" aria-hidden="true"></i>`);
            }
            catch (error) {
                this._talk.broadcast(`Something wrong happened while updating the organization! <i class="fa fa-frown-o" aria-hidden="true"></i>`);
            }
            this.cancel();
        });
    }
    getNetworkCodesToUpdate() {
        const { dfpNetworkCodes } = this.editOrg;
        return ((dfpNetworkCodes &&
            dfpNetworkCodes.filter(({ displayName, id }) => {
                for (const code of this.organization.dfpNetworkCodes) {
                    if (code.id === id && code.displayName !== displayName) {
                        return true;
                    }
                }
                return false;
            })) ||
            []);
    }
    updateDfpNetworkCodes(networkCodesToUpdate) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all(networkCodesToUpdate.map(network => this._lia
                .updateDfpNetwork(network.id, {
                networkCode: network.networkCode,
                displayName: network.displayName,
            })
                .catch(err => {
                this._talk.broadcast(`<h2>Unable to update DFP Network Code(${network.networkCode})</h2>`);
                console.error(err);
            })));
        });
    }
    delete() {
        return this._admin
            .deleteOrganization(this.organization)
            .then(() => __awaiter(this, void 0, void 0, function* () {
            this._talk.broadcast("Organization deleted.");
            yield this._organizations.pull();
            this._cd.markForCheck();
        }))
            .catch(() => this._talk.broadcast("Failure occurred while deleting organization."));
    }
    canUpdateDfpNetworkCodes() {
        return this.editOrg.isTypeClient() && _.get(this.permission, '["admin-organization--update_dfp"]');
    }
    openUpdateDfpNetworksModal() {
        this.modal.open(update_dfp_networks_modal_component_1.UpdateDfpNetworksModalComponent, (0, angular2_modal_1.overlayConfigFactory)({ organization: this.editOrg }))
            .then(dialogRef => {
            dialogRef.result.then(result => {
                if (result.hasUpdated) {
                    this.reload.emit();
                }
            });
        });
    }
};
exports.OrganizationListRowEditComponent = OrganizationListRowEditComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", organization_1.Organization)
], OrganizationListRowEditComponent.prototype, "organization", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", permission_1.Permission)
], OrganizationListRowEditComponent.prototype, "permission", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], OrganizationListRowEditComponent.prototype, "roleDropDownOrg", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], OrganizationListRowEditComponent.prototype, "reload", void 0);
exports.OrganizationListRowEditComponent = OrganizationListRowEditComponent = __decorate([
    (0, core_1.Component)({
        selector: "organization-list-row-edit",
        templateUrl: "app/organization-list-row-edit.component.html",
        styleUrls: ["styles/admin.component.css"],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        lineitem_automation_service_1.LineAutomationService,
        organizations_service_1.OrganizationsService,
        notification_service_1.NotificationService,
        angular2_modal_2.Modal])
], OrganizationListRowEditComponent);
//# sourceMappingURL=organization-list-row-edit.component.js.map